import React from 'react';
import { isEmpty } from 'lodash';

import ListItem from '@material-ui/core/ListItem';

import styles from './POI.module.scss';
import {
  MenuItem,
  Menu,
  IconButton,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
export default class POI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {anchorEl: null};

    this.onDragPOIStart = this.onDragPOIStart.bind(this);
    this.onDragPOIOver = this.onDragPOIOver.bind(this);
    this.onDropPOI = this.onDropPOI.bind(this);
  }

  onDragPOIStart(e, index) {
    e.dataTransfer.setData('text/plain', index);

    e.stopPropagation();
  }

  onDragPOIOver(e, index) {
    e.preventDefault();
    e.stopPropagation(); // Don't send it further
    this.props.highlightDestinationFunc(index);
  }

  onDropPOI(e, category, index) {
    if (category === 'complete') {
      const from = e.dataTransfer.getData('text');
      const to = index;
      this.props.onSwapPOIsFunc(from, to);
    }

    e.stopPropagation();
  }  

  render() {
    const open = Boolean(this.state.anchorEl);
    const handleClick = (event) => {
      this.setState({anchorEl : event.currentTarget});
    };
    const handleClose = () => {
      this.setState({anchorEl : null});
    };

    const { poi } = this.props;
    if (isEmpty(poi)) return null;
    const address = poi.where ? poi.where.address : '';

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let paddingRight,
      paddingBottom = '0px';

    if (this.props.highlight === poi.index) {
      borderColor = '#52A8EF';
      borderStyle = 'dashed';
      paddingRight = '18px';
      paddingBottom = '8px';
    }
    return (
      <div
        style={{
          borderColor,
          borderStyle,
          paddingRight,
          paddingBottom,
        }}
      >
        <ListItem
          className={styles.root}
          draggable
          onDragStart={e => this.onDragPOIStart(e, poi.index)}
          onDragOver={e => this.onDragPOIOver(e, poi.index)}
          onDrop={e => this.onDropPOI(e, 'complete', poi.index)}
        >
          <div className={styles.clue}>
            <div>{poi.name}</div>
            {this.props.showCategory && <div className={styles.extraLargeColumn}>{address}</div>}
            {this.props.showCategory && <div className={styles.largeColumn}>
              <span className={styles.action}>Map</span>
            </div>}
            <div>
            <IconButton  
              aria-label="more"
              id="long-button"
              aria-controls={open ? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              style={{padding: '5px'}}
              onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>
            <Menu 
              id="long-menu" 
              MenuListProps={{
                'aria-labelledby': 'long-button',
              }}
              anchorEl={this.state.anchorEl}
              open={open}
              onClose={handleClose}>
                <MenuItem style={{color:"#434F69",fontFamily: 'gilroy-regular'}} onClick={() => {this.props.onClickPOIFunc(poi);handleClose();}}>Edit</MenuItem>
                <MenuItem style={{color:"#434F69",fontFamily: 'gilroy-regular'}} onClick={() => {this.props.onDeletePOIFunc(poi.index);handleClose();}}>Remove</MenuItem>
            </Menu>
            </div>
          </div>
        </ListItem>
      </div>
    );
  }
}
